(() => {
  // Respect reduced motion
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const canvas = document.createElement('canvas');
  canvas.id = 'obsession-particles';
  document.body.appendChild(canvas);

  const ctx = canvas.getContext('2d', { alpha: true });

  // ---- TUNE THESE ----
  const COLOR = 'rgba(220, 0, 0, 0.85)';   // Obsession red (adjust if you want)
  const COUNT_DESKTOP = 55;
  const COUNT_MOBILE = 30;
  const MIN_R = 1.0;
  const MAX_R = 2.6;
  const SPEED = 0.22; // lower = slower
  // ---------------------

  let w, h, dpr;
  let particles = [];

  function resize() {
    dpr = Math.max(1, Math.min(2, window.devicePixelRatio || 1));
    w = window.innerWidth;
    h = window.innerHeight;

    canvas.style.position = 'fixed';
    canvas.style.inset = '0';
    canvas.style.width = '100%';
    canvas.style.height = '100%';
    canvas.style.pointerEvents = 'none';
    canvas.style.zIndex = '9999'; // on top of all sections
    canvas.style.mixBlendMode = 'screen'; // looks nice on dark backgrounds

    canvas.width = Math.floor(w * dpr);
    canvas.height = Math.floor(h * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    const targetCount = (w < 768) ? COUNT_MOBILE : COUNT_DESKTOP;
    if (particles.length !== targetCount) initParticles(targetCount);
  }

  function initParticles(n) {
    particles = Array.from({ length: n }).map(() => ({
      x: Math.random() * w,
      y: Math.random() * h,
      r: MIN_R + Math.random() * (MAX_R - MIN_R),
      vx: (Math.random() - 0.5) * (SPEED * 2),
      vy: (Math.random() - 0.5) * (SPEED * 2),
      tw: 0.6 + Math.random() * 0.6, // twinkle factor
      ph: Math.random() * Math.PI * 2
    }));
  }

  function step(t) {
    ctx.clearRect(0, 0, w, h);
    ctx.fillStyle = COLOR;

    for (const p of particles) {
      // Move
      p.x += p.vx;
      p.y += p.vy;

      // Wrap edges
      if (p.x < -10) p.x = w + 10;
      if (p.x > w + 10) p.x = -10;
      if (p.y < -10) p.y = h + 10;
      if (p.y > h + 10) p.y = -10;

      // Slight twinkle
      const a = 0.45 + 0.35 * Math.sin((t * 0.002) + p.ph) * p.tw;

      ctx.globalAlpha = a;
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
      ctx.fill();
    }

    ctx.globalAlpha = 1;
    requestAnimationFrame(step);
  }

  window.addEventListener('resize', resize, { passive: true });
  resize();
  requestAnimationFrame(step);
})();
